export enum MDropdownIcon {
  default = '',
  calendar = 'calendar'
}
